module.exports = __webpack_public_path__ + "static/img/lres3.4cc984c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lres3.png
// module id = vQhs
// module chunks = 1